
import widgetCustomScpm from './widgetCustomScpm.vue';

export default {
  install(Vue) {
    Vue.component(widgetCustomScpm.name, widgetCustomScpm);
  },
};
